<template>
  <div :class="`wrapper ${theme}`" v-if="show">
    <div class="nfplus-footer">
      <img class="nfplus-footer__logo" src="https://static.nfapp.southcn.com/images/logo.png" />
      <div class="nfplus-footer__info">
        <div class="nfplus-footer__info-title">南方Plus</div>
        <div class="nfplus-footer__info-desc">广东头条新闻资讯平台</div>
      </div>
      <div v-if="openAppOptions" class="nfplus-footer__btn" v-openapp="{options:openAppOptions}">打开</div>
    </div>
  </div>
</template>
<script>
import openApp from "../../common/utils/openApp.js";
import getSystemInfo, {
  isInWechatMP,
} from "../../common/utils/getSystemInfo.js";
import getParamsFromUrl from "../../common/utils/getParamsFromUrl.js";

export default {
  name: "OpenApp",
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    theme: {
      type: String,
      default: "bright",
    },
  },
  data() {
    return {
      show: !getSystemInfo().isNfPlus && !isInWechatMP(),
    };
  },
  computed: {
    openAppOptions() {
      const res = this.options ? {
        id: getParamsFromUrl()['articleId'] || 12,
        title: '南方plus客户端',
        needClipboard: true,
        address: window.location.href,
        ...this.options,
        shareType: "reporterAssemblePage",
        isActivity: false,
      } : undefined
      
      return res
    }
  },
  methods: {
    handleOpen() {
      openApp();
    },
  },
};
</script>
<style lang="scss" scoped>
.nfplus-footer {
  display: flex;
  align-items: center;
  top: 0;
  padding: 0.22rem 0.3rem;
  width: 100%;
  height: 1.14rem;
  flex-shrink: 0;
  max-width: 7.5rem;
  background-color: #fff;
  border-top: 0.02rem solid #eee;
  box-sizing: border-box;
  position: relative;
  z-index: 1000;

  &__logo {
    width: 0.7rem;
    height: 0.7rem;
    border-radius: 0.1rem;
  }

  &__info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 0.2rem;

    &-title {
      font-size: 0.26rem;
      font-weight: bold;
      line-height: 0.38rem;
    }

    &-desc {
      font-size: 0.24rem;
      line-height: 0.36rem;
      font-weight: 500;
      color: #999;
    }
  }

  &__btn {
    position: absolute;
    top: 50%;
    right: 0.3rem;
    width: 1.2rem;
    height: 0.58rem;
    line-height: 0.58rem;
    font-size: 0.3rem;
    font-weight: 500;
    border-radius: 0.3rem;
    background-color: #f64e45;
    text-align: center;
    color: #fff;
    transform: translateY(-50%);
  }
}

.dark {
  .nfplus-footer {
    background: rgba(0, 0, 0, 0.65);

    &__info {
      &-title {
        font-size: 0.26rem;
        color: #ffffff;
      }

      &-desc {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
}
</style>
